import React from 'react';
import {Translation} from 'react-i18next';
import {Form, Select} from 'antd';


const PlannerDocumentsTypeInput = ({name, label, rules=null, disabled=false, ...props}) => {

  const options = [
    {
      value: 1,
      label: "planner_documents_document_type_1",
    },
    {
      value: 2,
      label: "planner_documents_document_type_2",
    },
  ];

  return (
    <Translation>{(t) => 
      <div className="form-group">
        <Form.Item
          name={name}
          label={label}
          rules={rules}
        >
          <Select disabled={disabled}>
            {options.map(x => <Select.Option key={x.value} value={x.value}>{t(x.label)}</Select.Option>)}
          </Select>
        </Form.Item>
      </div>
    }</Translation>
  );
}

export default PlannerDocumentsTypeInput;
